import {NgModule} from '@angular/core'
import {CheckRatesOnNullPipe, LevelPickerComponent} from './picker/level.picker.component'
import {CommonModule} from '@angular/common'
import {NzModule} from '../../nz.module'
import {FormsModule} from '@angular/forms'
import {LevelPickerService} from './level.picker.service'

@NgModule({
  declarations: [
    LevelPickerComponent,
    CheckRatesOnNullPipe
  ],
  imports: [
    CommonModule,
    NzModule,
    FormsModule,
    // Pipes
  ],
  exports: [
    LevelPickerComponent,
    CheckRatesOnNullPipe
  ],
  providers: [
    LevelPickerService
  ]
})
export class LevelPickerModule{
  constructor() {
  }
}
